export const TIME_FORMATS = ['HH:mm', 'H:mm', 'HH', 'H'];
export const DATE_FORMATS = ['DDMMYYYY', 'YYYYMMDD', 'MMDDYYYY', 'YYYY-MM-DD', 'DD/MM/YYYY']